<template>
  <div class="home-content-box news-box">
    <div class="background-white-box left-box border-top" />
    <div class="home-content-body body-max-container">
      <ul>
        <li>
          <div class="home-content-info">
            <div class="home-content-info-body">
              <div class="title">最新消息</div>
              <div class="subTitle">News</div>
              <div v-if="getNews" class="content">
                <span>
                  {{ getNews.title }}
                  <br />
                  {{ getNews.newsContent }}
                </span>
              </div>
            </div>
            <div class="enter-btn" @click="goNews">
              <img src="../../../assets/img/icon-arrow-right.svg" alt />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeNews",
  props: {
    newsList: {
      type: Array,
      required: true
    }
  },
  computed: {
    /**
     * @return {NewsModel}
     */
    getNews() {
      return this.newsList[0]
    }
  },
  data() {
    return {};
  },
  methods: {
    goNews() {
      this.$router.push({ name: "News" });
    },
  },
};
</script>

<style lang="scss" scoped>
.news-box {
  .enter-btn {
    img {
      bottom: 20% !important;
    }
  }
  ul {
    background-image: url("../../../assets/img/home/home-news-bg.jpg");
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
